export default "__VITE_ASSET__a8ab9003__"